import { createContext, useContext, useState, useCallback } from "react";

// Global controller for the login/signup popup. Any component can call
// openAuth("login" | "signup") to surface the modal — auth is never mandatory,
// so this only gates favourites and the /my-space dashboard.
const AuthModalContext = createContext(null);

export function AuthModalProvider({ children }) {
  const [state, setState] = useState({ open: false, mode: "login" });

  const openAuth = useCallback((mode = "login") => {
    setState({ open: true, mode });
  }, []);

  const closeAuth = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const setMode = useCallback((mode) => {
    setState((s) => ({ ...s, mode }));
  }, []);

  return (
    <AuthModalContext.Provider value={{ ...state, openAuth, closeAuth, setMode }}>
      {children}
    </AuthModalContext.Provider>
  );
}

export const useAuthModal = () => useContext(AuthModalContext);
